import React from 'react'
import { Connect } from '../AccountComponents/Connect'

export const Account = () => {
  return (
    <>
    <Connect/>
    </>
  )
}